import { pathOr } from 'ramda'
import { useSelector } from 'react-redux'

const useEmbedLocale = () => useSelector(state => pathOr('en', ['embed', 'configuration', 'locale'], state))

export default useEmbedLocale